import React, { useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Checkbox,
  FormTemplateProfile,
  PreLoading /*  ToggleSwitch */,
} from "@tripian/react";
import { api, easy } from "@tripian/core";
import Model from "@tripian/model";
import { useNavigate } from "react-router-dom";
import ICombinedState from "../../redux/model/ICombinedState";

import {
  DELETE_USER,
  USER_PROFILE,
  USE_TRIP_URL,
} from "../../constants/ROUTER_PATH_TITLE";
import { changeUser } from "../../redux/action/user";
import useQuestionProfile from "../../hooks/useQuestionProfile";
import AppNav from "../../App/AppNav/AppNav";
import { getLocalStorageToken } from "../../App/AppWrapper/localStorages";
import useNotificationSettings from "../../hooks/useNotificationSettings";
import useTranslate from "../../hooks/useTranslate";
// import classes from "./UserProfile.module.scss";

const UserProfile = () => {
  const {
    loadingNotificationSettings,
    notificationSettings,
    isLoadingNotificationSettingUpdate,
    updateNotificationsSetting,
  } = useNotificationSettings();
  const { loadingQuestionsProfile, questionsProfile } = useQuestionProfile();
  const user = useSelector((state: ICombinedState) => state.user.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { t } = useTranslate();

  document.title = USER_PROFILE.TITLE(t("user.profile"));

  useEffect(() => {
    const redirectToUseTripUrl = () => {
      navigate(USE_TRIP_URL.PATH, { replace: true });
    };

    if (!window.tconfig.SHOW_USER_PROFILE && window.tconfig.LOGIN_WITH_HASH) {
      redirectToUseTripUrl();
    }
  }, [navigate]);

  const isSocialUser = useMemo(() => {
    try {
      const token = getLocalStorageToken();
      if (token) {
        const tokenPayload: Model.TokenPayload | undefined =
          easy.parseToken(token);
        return (
          tokenPayload?.["cognito:username"].split("").includes("_") ?? false
        );
      }

      return false;
    } catch (error) {
      return false;
    }
  }, []);

  const updateCallback = (updatedUser: Model.User) => {
    dispatch(changeUser(updatedUser));
  };

  const update = (value: Model.UserUpdateRequest) => api.userUpdate(value);

  if (!user) return null;

  return (
    <div
      className="full-center-x"
      style={
        window.tconfig.IMAGE_PATHS.APP_BACKGROUND_IMG_URL
          ? {
              background: `url(${window.tconfig.IMAGE_PATHS.APP_BACKGROUND_IMG_URL})`,
            }
          : {}
      }
    >
      <AppNav header={USER_PROFILE.HEADER?.(t("user.profile"))} />

      {loadingQuestionsProfile ? (
        <div className="flex items-center justify-center min-h-screen">
          <PreLoading />
        </div>
      ) : (
        <>
          <FormTemplateProfile
            user={user}
            profileQuestions={questionsProfile || []}
            updateUser={update}
            updateCallback={updateCallback}
            cancel={() => {
              navigate(-1);
            }}
            canChangePassword={
              !isSocialUser &&
              window.tconfig.SHOW_CHANGE_PASSWORD &&
              !window.tconfig.GUEST_LOGIN
            }
            forgotPassword={() => navigate("/forgot-password")}
            t={t}
          />

          {window.tconfig.SHOW_NOTIFICATION_SETTINGS &&
            loadingNotificationSettings === false &&
            0 < notificationSettings.length && (
              <>
                <div className="pl-4 mb-4 font-bold">
                  {t("user.profile.notificationSettings")}
                </div>
                <div className="flex flex-col">
                  {notificationSettings.map(ns => {
                    return (
                      <div
                        key={ns.id}
                        className="flex row justify-between items-center w-full h-14 px-4 my-0"
                      >
                        <h2>{ns.name}</h2>
                        {isLoadingNotificationSettingUpdate(ns.id) ? (
                          <div className="pr-7">
                            <PreLoading size="small" />
                          </div>
                        ) : (
                          <>
                            <Checkbox
                              text={""}
                              style={{ marginRight: "0" }}
                              domId={ns.id.toString()}
                              checked={ns.checked}
                              onChange={v => {
                                updateNotificationsSetting(ns.id, v);
                              }}
                            />
                          </>
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          <div className="text-center my-3 pb-8 mt12">
            <Button
              className="w-full"
              style={{ backgroundColor: "#ffffff", color: "#dc2626" }}
              text={t("user.deleteUser.deleteBtn")}
              onClick={() => navigate(DELETE_USER.PATH)}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default UserProfile;
